/* eslint-disable */
import React from 'react'
import { Box } from '@mui/material'

import Map from 'components/Reporting/Overview/GraphicalDetails/ContributionsLocation/ClusterMap/Map'
import { MapProps as MapPropsTypes } from 'types/Map'

const ClusterMap = (props: MapPropsTypes) => {
  const { height, contributionsLocationData } = props

  return (
    <Box height={height || '28.75rem'}>
      <Map contributionsLocationData={contributionsLocationData} />
    </Box>
  )
}

export default ClusterMap
